<div class="like-wrapper">
  <div [class.is-liked]="passedInlike.likedByMe" style="margin-bottom:5px">

    @if (updatingLike) {
      <ebs-spinner [spinnerMessage]="''" [faColour]="'#000'" [faFont]="'0.9'" [boxPadding]="'0'">
      </ebs-spinner>
    }
    @if (!updatingLike) {
      <div class="spinner-wrapper">
        @if (!isMyPostOrReply) {
          <i class="btn fa fa-thumbs-up fa-1x fa-border" role="button" aria-label="like button" (click)="clickedLike()"
          aria-hidden="true"></i>
        }
        <span class="like-text" role="button"> {{passedInlike.numberOfLikes ? passedInlike.numberOfLikes : 0}}
          @if (passedInlike.numberOfLikes != 1) {
            <span>likes</span>
          }
          @if (passedInlike.numberOfLikes === 1) {
            <span>like</span>
          }
        </span>
      </div>
    }

  </div>
  @if (showError) {
    <ebs-message-simple [displayMessage]="errorMessage"></ebs-message-simple>
  }
</div>